'use es6';

import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getCurrentBenderProject = basicSelector(state => state.bender.currentProject);